const STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
  open: "bg-amber-50 text-amber-700 border-amber-200",
  closed: "bg-slate-100 text-slate-600 border-slate-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  payment: "bg-blue-50 text-blue-700 border-blue-200",
  license: "bg-violet-50 text-violet-700 border-violet-200",
  default: "bg-slate-100 text-slate-700 border-slate-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
};

const LABELS = {
  active: "Aktiv",
  inactive: "Inaktiv",
  open: "Offen",
  closed: "Geschlossen",
  resolved: "Erledigt",
  pending: "Wartend",
  accepted: "Angenommen",
  rejected: "Abgelehnt",
  sent: "Gesendet",
  failed: "Fehlgeschlagen",
  payment: "Zahlungs-Provision",
  license: "Lizenz-Provision",
};

export default function StatusBadge({ status, label, className = "", testid }) {
  const key = (status || "default").toLowerCase();
  const style = STYLES[key] || STYLES.default;
  const text = label || LABELS[key] || status || "—";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold uppercase tracking-wider border rounded-sm ${style} ${className}`}
    >
      {text}
    </span>
  );
}
